import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC, RefObject } from "react";
import { Modal } from "components/Modal/Modal";
import { PartnerModalContent } from "types/graphql/generated";
import { PartnerInfo } from ".";

interface Props {
  content: PartnerModalContent;
  isOpen: boolean;
  focusAfterClose?: RefObject<HTMLElement>;
  onClose: () => void;
}

const PartnerModal: FC<Props> = withErrorBoundary(({ isOpen, focusAfterClose = undefined, onClose, content }) => {
  return (
    <Modal isOpen={isOpen} focusAfterClose={focusAfterClose} onClose={onClose} ariaLabel="Partner info" withCloseButton>
      <PartnerInfo content={content} />
    </Modal>
  );
}, {});

gql`
  fragment PartnerModalContent on ComponentNestedFeatures4Partners {
    ...PartnerInfoContent
  }
`;

export { PartnerModal };
